import React, { useState } from 'react';
import './TechStack.css';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core';
import Modal from 'react-modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import TechStackModalView from '../TechStackModalView/TechStackModalView';
import techStackSvg from '../../../assets/svgs/techstack.svg';

const contentStyles = {
  content: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
};

const TechStack = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <Box>
      <Card>
        <CardActionArea onClick={() => setIsModalOpen(true)}>
          <CardMedia
            component='img'
            alt='Timeline'
            height='200'
            image={techStackSvg}
            title='Timeline'
          />
          <CardContent
            className='align-center'
            onClick={() => setIsModalOpen(true)}
          >
            <Typography gutterBottom variant='h5' component='h2'>
              Tech Stack
            </Typography>
            <Typography variant='body2' color='textSecondary' component='p'>
              All technologies I have dabbled in so far
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions className='align-center'>
          <Button
            size='small'
            color='primary'
            onClick={() => setIsModalOpen(true)}
          >
            Show Tech Stack
          </Button>
        </CardActions>
      </Card>
      <Modal
        closeTimeoutMS={300}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        style={contentStyles}
      >
        <div className='close-modal-button-top'>
          <IconButton onClick={() => setIsModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className='modal-content'>
          <h1>Tech Stack</h1>
          <TechStackModalView />
        </div>
        <div className='close-modal-button-bottom'>
          <Button
            size='large'
            variant='contained'
            color='primary'
            className='close-modal'
            onClick={() => setIsModalOpen(false)}
          >
            Close This
          </Button>
        </div>
      </Modal>
    </Box>
  );
};

export default TechStack;
